// Finds the first focusable element within a tabpanel
export const findFirstFocusableElement = (tabpanelId: string): HTMLElement | null => {
  const tabpanel = document.getElementById(tabpanelId);
  if (!tabpanel) return null;

  // Check if tabpanel is visible (not hidden)
  if (tabpanel.hasAttribute('hidden')) return null;

  // Query selector for focusable elements
  const focusableSelectors = [
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]',
  ].join(', ');

  const focusableElements = tabpanel.querySelectorAll<HTMLElement>(focusableSelectors);

  // Filter out elements that are not visible or have display: none
  for (const element of focusableElements) {
    const style = window.getComputedStyle(element);
    if (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      !element.hasAttribute('aria-hidden')
    ) {
      return element;
    }
  }

  // If no focusable element found, return the tabpanel itself if it has tabIndex
  if (tabpanel.hasAttribute('tabindex') && tabpanel.getAttribute('tabindex') !== '-1') {
    return tabpanel;
  }

  return null;
};
